import React from "react";
import axiosInstance from "../../../interceptors";
import { baseUrl } from "../../../config/config";
import { toast } from "../../../components/shared/toast";
import StageList from "./StageList";

// Reject + email follow-up. The pipeline reject endpoint moves status
// in the DB but doesn't send the candidate-facing email — same gap as
// /admin/applications. Fire the V022 REJECTED template after the
// status flips so the candidate gets the "View detailed feedback →"
// link. Best-effort: status flip succeeds independently.
async function rejectAndEmail(c) {
  await axiosInstance.post(`${baseUrl}/job-posting/pipeline/${c.userId}/${c.jobId}/reject`);
  if (!c.email) return; // No recipient on file — silent skip.
  try {
    await axiosInstance.post(`${baseUrl}/job-posting/stage-emails/send`, {
      stageTo: "REJECTED",
      candidateId: c.userId,
      jobId: c.jobId,
      recipientEmail: c.email,
      variables: {
        candidateName: c.name || c.email,
        jobTitle: c.position || `Job #${c.jobId}`,
        companyName: "Ample Hire",
        recruiterName: "the hiring team",
      },
    });
    toast.success("Rejected — email sent");
  } catch (e) {
    toast.error("Rejected, but email failed", {
      description: e?.response?.data?.message || e?.message || "Resend from the candidate report.",
    });
  }
}

export default function Shortlisted() {
  return (
    <StageList
      stage="shortlisted"
      title="Shortlisted"
      subtitle="Candidates past screening — ready for offer decision"
      actions={[
        {
          label: "Make offer",
          onClick: (c) =>
            axiosInstance.post(`${baseUrl}/job-posting/pipeline/${c.userId}/${c.jobId}/offer`),
        },
        {
          label: "Reject",
          danger: true,
          onClick: rejectAndEmail,
        },
      ]}
    />
  );
}
